import React, { useState, useEffect } from "react";
import editorStore from "../../stores/EditorStore";
import PreviewImageModal from "../Canvas/PreviewImage";
import loadingSpinner from "../../assets/img/Spinner.svg";

const PhotobookPreview = ({ onClose }: { onClose: () => void }) => {
  const [isReady, setIsReady] = useState(false);
  const [previewImages, setPreviewImages] = useState<string[]>([]);

  useEffect(() => {
    const generatePreviews = async () => {
      const json = editorStore.toJSON();
      if (!json.pages?.length) { setIsReady(true); return; }

      // Generate all pages in parallel — no artificial delays
      const urls = await Promise.all(
        (json.pages as Array<{ id: string }>).map(page => editorStore.toDataURL({ pageId: page.id }))
      );

      setPreviewImages(urls.filter(Boolean));
      setIsReady(true);
    };

    generatePreviews();
  }, []);

  // Show a centered spinner while generating, then the swiper modal when ready
  if (!isReady) {
    return (
      <div style={{
        position: "fixed", inset: 0, zIndex: 50,
        background: "rgba(0,0,0,0.45)",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 12,
      }}>
        <img src={loadingSpinner} alt="Generating preview…" style={{ width: 64, height: 64 }} />
        <span style={{ color: "#fff", fontSize: 14 }}>Generating preview…</span>
      </div>
    );
  }

  return (
    <PreviewImageModal
      isOpen={true}
      onClose={onClose}
      imageUrl={previewImages}
    />
  );
};

export default PhotobookPreview;
